module.exports = __webpack_public_path__ + "static/media/yoga-retreat-banner-mobile.90ee8b32.webp";